import { first, Observable, switchMap, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const url = state.url;
    return this.authService.checkAuth().pipe(
      switchMap(() => {
        return this.authService.signedIn$;
      }),
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.authService.pushTmpUrl(url);
          this.router.navigateByUrl('auth/login');
        } else {
          const url = this.authService.popTmpUrl();
          if (url) {
            this.router.navigateByUrl(url);
          }
        }
      }),
      first()
    );
  }
}
